<template>
	<core-form-fancy-select-input
		:multiple="true"
		:options="options"
		:value="value"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		options : {
			type     : Array,
			required : true,
		},
		value : Array,
	},
}
</script>
